/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_validation_username_invalid_chars = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Username can only contain letters, numbers, and underscore`)
};

const zh_hans1_settings_validation_username_invalid_chars = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用户名只能包含字母、数字和下划线`)
};

const zh_hant1_settings_validation_username_invalid_chars = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`使用者名稱只能包含英文字母、數字與底線（_）`)
};

const fr_settings_validation_username_invalid_chars = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le nom d’utilisateur ne peut contenir que des lettres, des chiffres et un underscore`)
};

const de_settings_validation_username_invalid_chars = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername darf nur Buchstaben, Zahlen und Unterstrich enthalten`)
};

const ja_settings_validation_username_invalid_chars = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名には英数字とアンダースコアのみ使用できます`)
};

const ko_settings_validation_username_invalid_chars = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사용자 이름에는 문자, 숫자, 밑줄(_)만 사용할 수 있습니다`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "zh-Hans" | "zh-Hant" | "fr" | "de" | "ja" | "ko" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_validation_username_invalid_chars = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_validation_username_invalid_chars(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_validation_username_invalid_chars", locale)
	if (locale === "en") return en_settings_validation_username_invalid_chars(inputs)
	if (locale === "zh-Hans") return zh_hans1_settings_validation_username_invalid_chars(inputs)
	if (locale === "zh-Hant") return zh_hant1_settings_validation_username_invalid_chars(inputs)
	if (locale === "fr") return fr_settings_validation_username_invalid_chars(inputs)
	if (locale === "de") return de_settings_validation_username_invalid_chars(inputs)
	if (locale === "ja") return ja_settings_validation_username_invalid_chars(inputs)
	return ko_settings_validation_username_invalid_chars(inputs)
};